import type { BranchChangesets } from '@festina/configuration-general-types/configuration'
import { ConfigurationRepositoryBranchesService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryBranchesService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { fetchConciseBranchKeyPrefix } from '../keys/configuration'

type InputArguments = {
  server: ConfigurableServer
  branchName: string
  configurationData: BranchChangesets
}

export const useImportBranchChangesets = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: async ({
      server,
      branchName,
      configurationData,
    }: InputArguments) => {
      await ConfigurationRepositoryBranchesService.branchServicePostPostBranchChangesets(
        {
          componentName: server.toLocaleLowerCase(),
          branchName,
          requestBody: configurationData,
        },
      )
    },
    onSuccess: (_, variables) =>
      client.invalidateQueries({
        queryKey: fetchConciseBranchKeyPrefix({
          server: variables.server,
          branchName: variables.branchName,
        }),
      }),
  })
}
